import { createFeatureSelector, createSelector } from '@ngrx/store';
import { PermissionState } from '../reducers/permission.reducer';

 
export const selectPermissionState =
  createFeatureSelector<PermissionState>('permission');

 
export const selectPermissionsData = createSelector(
  selectPermissionState,
  (state) => state.data || []
);

 
export const selectAllPermissionCodes = createSelector(
  selectPermissionsData,
  (data) => data?.map((p: any) => p.code) || []
);

 
export const selectHasPermission = (code: string) =>
  createSelector(selectAllPermissionCodes, (codes) => codes.includes(code));

 
export const selectPermissionsLoading = createSelector(
  selectPermissionState,
  (state) => state.loading
);
